import {Container} from './components/Container'
import {ReactComponent as FacebookIcon} from '../../../../assets/facebook.svg'
import {ReactComponent as InstagramIcon} from '../../../../assets/instagram.svg'
import {ReactComponent as XIcon} from '../../../../assets/twitter.svg'
import {SocialLink} from '../SocialLink'
import {useContext} from 'react'
import {CustomLanding36252Context} from '../../../../reducer'

export const SocialLinks = () => {
  const [state] = useContext(CustomLanding36252Context)

  return (
    <Container inverse={state.language === 'ar'}>
      <SocialLink icon={<FacebookIcon />} href="https://facebook.com/TauromarketsOfficial/" />
      <SocialLink icon={<InstagramIcon />} href="https://instagram.com/tauromarkets" />
      <SocialLink icon={<XIcon />} href="https://x.com/tauromarkets/" />
    </Container>
  )
}
